export const PROJECTS_COLLECTION_NAME = "ProyectosOT";
export const PLACES_COLLECTION_NAME = "EspaciosOT";
export const CHECKLISTS_COLLECTION_NAME = "ChecklistsOT";
export const ASSIGNED_PLACES_COLLECTION_NAME =
	"EspaciosAsignadosOT";
export const CHECKLIST_RESPONSES_COLLECTION_NAME =
	"RespuestasOT";

